
export const WEB = 'web';

export const WEB_VIEW = 'web_view';

export const CLIENT_TYPE = {
  WEB,
  WEB_VIEW,
  
  getClientTypeFromToken(token) { return token && token['as:client_id'];  },
  
  isWeb(token) { return Boolean(this.getClientTypeFromToken(token) === this.WEB); },
  isWebView(token) { return Boolean(this.getClientTypeFromToken(token) === this.WEB_VIEW); },
  
  shouldLogoutOnTimeout(token) { return this.isWeb(token); }
};
